import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { openCallKeys } from "./queryKeys";
import type { OpenCall, OpenCallFormFields } from "../types";

/**
 * Create new OpenCall
 */
const createOpenCall = (formData: OpenCallFormFields) =>
  api.post<OpenCall>("/open-call/create", {
    body: JSON.stringify({
      slug: formData.id,
      openCall: { ...formData, isSelectionCompleted: false },
    }),
  });

/**
 * Custom hook to create new OpenCall and manage state
 */
const useCreateOpenCall = () => {
  const queryClient = useQueryClient();

  return useMutation(createOpenCall, {
    onSuccess: (updates) => {
      // Update cache with new data
      queryClient.setQueryData(openCallKeys.detail(updates.id), updates);
      // Invalidate any cached lists that might contain this open call
      // TODO: if Elastic query returns old cache without updates, use `setQueriesData()` instead
      queryClient.invalidateQueries(openCallKeys.lists());
    },
  });
};

export { useCreateOpenCall };
